import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-auto-authorization-setting-ab',
  templateUrl: './auto-authorization-setting-ab.component.html',
  styleUrls: ['./auto-authorization-setting-ab.component.scss']
})
export class AutoAuthorizationSettingAbComponent implements OnInit {

  /* チェーンフラグ */
  public isChain: boolean = true;

  constructor() { }

  ngOnInit(): void {
  }

}
